import { ChangeEvent } from 'react';
import { useContextSelector as useCS } from 'use-context-selector';
import { profileConfigSelectors } from 'domain/profileConfig/selectors';
import {
  NotificationSettings,
  ProfileConfigContext,
} from 'domain/profileConfig/ProfileConfigContext';
import { useGetNotificationsSettings } from 'view/pages/profile/hooks/useGetNotificationsSettings';
import { useUpdateNotificationsSettings } from 'view/pages/profile/hooks/useUpdateNotificationsSettings';
import { notificationsMockData } from 'view/pages/profile/helpers';
import * as CS from 'view/pages/profile/commonStyled';
import * as S from './styled';

const NotificationsSettings = () => {
  const notificationSettings: NotificationSettings = useCS(
    ProfileConfigContext,
    profileConfigSelectors.notificationSettings
  );

  const { isLoading: isSettingsLoading } = useGetNotificationsSettings();
  const { isLoading, updateNotificationSetting } = useUpdateNotificationsSettings();

  const handleUpdateChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { checked, name } = e.target;
    updateNotificationSetting({ [name]: checked });
  };

  return (
    <CS.ProfileMainWrapper>
      {notificationsMockData.map(({ sectionTitle, sectionSubTitle, items, separator }) => {
        return (
          <S.NotificationVisibilityGap key={sectionTitle} separator={separator.toString()}>
            <S.Header>
              <S.HeaderTitle>{sectionTitle}</S.HeaderTitle>
              <S.HeaderSubTitle>{sectionSubTitle}</S.HeaderSubTitle>
            </S.Header>
            <div>
              {items.map(({ name, label }) => {
                return (
                  <S.MainItem key={name}>
                    <p>{label}</p>
                    <S.CustomSwitch
                      name={name}
                      checked={notificationSettings[name]}
                      onChange={handleUpdateChange}
                      disabled={isLoading || isSettingsLoading}
                    />
                  </S.MainItem>
                );
              })}
            </div>
          </S.NotificationVisibilityGap>
        );
      })}
    </CS.ProfileMainWrapper>
  );
};

export default NotificationsSettings;
